module.exports = __webpack_public_path__ + "static/note-dismiss-do-968290ed0a11358e4786cb1fff3f1fe4.png";